import http from './http';

/**
 * Lista todos los servicios disponibles en el sistema (para la búsqueda por servicio).
 * Requiere el endpoint GET /servicios que se agrega al backend en la Etapa 3.
 * Respuesta esperada: [{ nombre, tipo }]
 */
export async function listarServicios() {
  const { data } = await http.get('/servicios');
  return data;
}

/** Servicios que ofrece un médico puntual. */
export async function serviciosDeMedico(idMedico) {
  const { data } = await http.get(`/medicos/${idMedico}/servicios`);
  return data;
}
